import { FC, JSX } from 'react';

import Ellipsis from '@semcore/ui/ellipsis';

import { TextBlock } from '@/entities/content/api/types';
import formatDuration from '@/shared/lib/utils/formatDuration';
import Button from '@/shared/ui/button';
import Edit2Icon from '@/shared/ui/icons/Edit2';

interface ITextBlockElementProps {
  triggerEdit: () => void;
  index: number;
  data: TextBlock;
}

const TextBlockElement: FC<ITextBlockElementProps> = ({
  triggerEdit,
  index,
  data: { start, end, content, url },
}): JSX.Element => {
  return (
    <div className="group flex w-56 flex-col gap-2 rounded-lg bg-[#f8f8f9] px-3 py-2">
      <div className="flex gap-2">
        <div className="h-5 w-5 rounded-full border border-blue pt-0.5 text-center">
          <div className="text-xs font-medium text-blue">{index}</div>
        </div>
        <div className="flex grow text-base font-light leading-5 text-black">
          {formatDuration(start)} - {formatDuration(end)}
        </div>
        <Button
          variant="function"
          size="sm"
          title=""
          iconAfter={<Edit2Icon />}
          className="hidden bg-blue/[.02] group-hover:flex"
          onClick={triggerEdit}
        />
      </div>
      <div className="flex flex-col">
        <div className="text-xs font-medium text-[#747580] text-secondary">
          Content
        </div>
        <div className="flex text-base font-light text-black">
          <Ellipsis trim="end" maxLine={2} tooltip>
            {content}
          </Ellipsis>
        </div>
      </div>
      <Ellipsis trim="end" tooltip>
        <a href={url} className="text-base font-light leading-6 text-blue">
          {url}
        </a>
      </Ellipsis>
    </div>
  );
};

export default TextBlockElement;
